module.exports = __webpack_public_path__ + "assets/arrow-l_icon.504d8b67.svg";